<template lang="pug" src="./form-make-appointment.pug"></template>

<script>
import axios from 'axios'
import api from 'api'
import BaseIcon from 'components/icon/icon'

export default {
  data: () => {
    return {
      patient_name: '',
      new_patient: '',
      email: '',
      phone: '',
      selected: '',
      appointment_monday: '',
      appointment_tuesday: '',
      appointment_wednesday: '',
      appointment_thursday: '',
      appointment_friday: '',
      appointment_8am: '',
      appointment_11am: '',
      appointment_2pm: '',
      hear: '',
      message: '',
      formSubmitted: false,
      postUrl: api + '/rg-mail/v1/make-appointment'
    }
  },
  methods: {
    validateBeforeSubmit () {
      this.$validator.validateAll()
      .then(result => {
        if (result) {
          this.formSubmitted = true
          this.onSubmit()
        } else {
          console.log(result)
        }
      })
      .catch((e) => {
        console.log(e)
      })
    },
    onSubmit () {
      axios.post(this.postUrl, {
        patient_name: this.patient_name,
        new_patient: this.new_patient,
        email: this.email,
        phone: this.phone,
        selected: this.selected,
        appointment_monday: this.appointment_monday,
        appointment_tuesday: this.appointment_tuesday,
        appointment_wednesday: this.appointment_wednesday,
        appointment_thursday: this.appointment_thursday,
        appointment_friday: this.appointment_friday,
        appointment_8am: this.appointment_8am,
        appointment_11am: this.appointment_11am,
        appointment_2pm: this.appointment_2pm,
        hear: this.hear,
        message: this.message
      })
      .then(res => {
        console.log(res)
      })
      .catch(e => { console.log(e) })
    }
  },
  components: {
    BaseIcon
  }
}
</script>



// WEBPACK FOOTER //
// form-make-appointment.vue?4ab5bf79